import Lenis from "lenis";

// Smooth scroll : lissage du scroll par interpolation (lerp), façon site de référence.
// Lenis conserve la position de scroll NATIVE (il anime window.scrollTo) → parallax,
// scroll-spy (IntersectionObserver) et header sticky continuent de fonctionner tels quels.
// Les events `scroll` natifs sont toujours émis : parallax.js profite du lissage sans changement.
// Désactivé sous prefers-reduced-motion (scroll natif instantané).
export function initSmoothScroll() {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  let lenis = null;

  // Ancres internes (#section) : on lisse via Lenis avec un offset = hauteur du header sticky
  // (équivalent du scroll-padding-top). Le skip-link reste natif → saut instantané + focus
  // géré par le navigateur (accessibilité).
  const onAnchorClick = (e) => {
    if (!lenis) return;
    const link = e.target.closest('a[href^="#"]');
    if (!link || link.classList.contains("c-skip-link")) return;
    const hash = link.getAttribute("href");
    if (hash === "#") return;
    const target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    const header = document.querySelector(".c-header");
    lenis.scrollTo(target, { offset: header ? -header.offsetHeight : 0 });
    history.pushState(null, "", hash);
  };

  const start = () => {
    if (lenis || reduce.matches) return;
    lenis = new Lenis({ lerp: 0.1, autoRaf: true });
    document.addEventListener("click", onAnchorClick);
  };

  const stop = () => {
    if (!lenis) return;
    document.removeEventListener("click", onAnchorClick);
    lenis.destroy();
    lenis = null;
  };

  start();
  reduce.addEventListener("change", () => (reduce.matches ? stop() : start()));

  // Pause/reprise du scroll lissé pendant qu'une modal est ouverte.
  document.addEventListener("modal:open", () => lenis?.stop());
  document.addEventListener("modal:close", () => lenis?.start());
}
